module.exports = __webpack_public_path__ + "static/media/gift.db7b9d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gift.png
// module id = 1378
// module chunks = 0